import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL, TEACHING_INSTRUCTOR_URL } from '../../data/images';

/** Emotional close. */
export function FinalCtaSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-80" data-mp="150tptv7hepne">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-81" data-mp="104biqoooif7w">
        <img src={TEACHING_INSTRUCTOR_URL} alt="Une formatrice en maquillage démontre une technique à ses élèves dans une académie lumineuse" width={1536} height={1024} loading="lazy" decoding="async" className="aspect-[3/2] w-full rounded-[22px] object-cover shadow-[0_40px_70px_-40px_rgba(34,30,36,0.55)]" data-id="element-82" data-mp="cdz46uyxhk8c" />
        <div className="text-center lg:text-left" data-id="element-83" data-mp="3pr15li5slduc">
          <h2 id="final-heading" className="font-display text-[2.2rem] font-bold leading-[1.05] text-brand-charcoal sm:text-[2.8rem]" data-id="element-84" data-mp="3kt91zqvsc3ab">
            Votre prochain cours ne devrait pas commencer par <Accent data-id="element-85" data-mp="2ppjtrdtfr8hs">une page blanche.</Accent>
          </h2>
          <p className="mt-5 text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-86" data-mp="2po0ik1mmznmv">
            Vous avez déjà l’expertise. Maintenant, vous avez le système.
          </p>
        </div>
      </div>

      <img src={MOCKUP_URL} alt="Le système complet Makeup Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-14 block w-full max-w-5xl" style={{
      filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
    }} data-id="element-87" data-mp="21se73zn8m7m1" />

      <div className="mx-auto mt-8 max-w-3xl text-center" data-id="element-88" data-mp="2fs5psdop8c6d">
        <p className="font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-89" data-mp="3n5hawrqbtxfo">
          Moins de temps à préparer. <Accent data-id="element-90" data-mp="3r6179t32sx0r">Plus de temps à enseigner.</Accent>
        </p>
        <CtaBlock label="Oui, je veux gagner du temps" note="Paiement unique • Accès immédiat • Sans abonnement" className="mt-8" data-id="element-91" data-mp="1s2asblqg82m8" />
      </div>
    </section>;
}